const ICONS = {
  entities: 'entities',
  rules: 'context-rules',
  intents: 'intents',
  dictionaries: 'dictionaries',
  'entity-features': 'entities',
  'dictionary-columns': 'dictionaries',
  'rule-groups': 'rule-group',
  contexts: 'contexts',
};

export default ICONS;
